import { Affix, Tabs, Row, Col, Typography } from "antd";
import { useState, useEffect } from "react";
import classNames from "classnames";
const { Paragraph } = Typography;

const TimelineItem = ({ label, title, description, body, img }) => {
    return (
      <div className="timeline-item">
        <Row gutter={60}>
          <Col 
            xs={{ span: 24 }}
            lg={{ span: 0 }}
          >
            <div className="landing-divider timeline-item-divider" />
          </Col>
  
          <Col 
            xs={{ span: 24 }}
            lg={{ span: 14 }} 
            className="timeline-text-col"
          >
            <div>
              <Paragraph className="timeline-label">
                {label}
              </Paragraph>
              <Paragraph className={classNames("timeline-title")}>
                {title}
              </Paragraph>
              <Paragraph className={classNames("timeline-description")}>
                {description}
              </Paragraph>
              <Paragraph className="timeline-body">
                {body}
              </Paragraph>
            </div>
          </Col>
  
          <Col 
            xs={{ span: 24 }}
            lg={{ span: 10 }}
          >
            <img src={img} className="timeline-img" />
          </Col>
        </Row>
      </div>
    )
  }
  

export const TreatmentTimeline = ({ timelineItems }) => {

    const [isTimelineVisible, setIsTimelineVisible] = useState(false);

    const scrollToSection = (key) => {
        const element = document.getElementById(`timeline-section-${key}`);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      };

    useEffect(() => {
        const timelineContainer = document.querySelector('.timeline-container');
        
        const observer = new IntersectionObserver(
          ([entry]) => {
            setIsTimelineVisible(entry.isIntersecting);
          },
          { threshold: 0.1 } // Trigger when 10% of the element is visible
        );
    
        if (timelineContainer) {
          observer.observe(timelineContainer);
        }
    
        return () => {
          if (timelineContainer) {
            observer.unobserve(timelineContainer);
          }
        };
      }, []);

    return (
        <div className="timeline-container">

            {isTimelineVisible && (
            <Affix offsetTop={0}>
            <Tabs 
                defaultActiveKey="1"
                onChange={scrollToSection}
                items={timelineItems.map(item => ({
                key: item.key,
                label: item.label
                }))}
                className="timeline-tabs"
            />
            </Affix>
            )}
            <div className="timeline-sections" >
            {timelineItems.map(item => (
                <div 
                key={item.key} 
                id={`timeline-section-${item.key}`}
                className="timeline-section"
                >
                    <TimelineItem 
                        label={item.children.label}
                        title={item.children.title}
                        description={item.children.description}
                        body={item.children.body}
                        img={item.children.img}
                    />
                </div>
            ))}
            </div>
    
        </div>  
    )
}

export default TreatmentTimeline;